import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import EnderecoProdutoService from "./enderecoProdutoService"
import FormList from 'base/FormList'

export default function EnderecoProdutoList() {

    const [service] = useState(() => new EnderecoProdutoService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_endp',
        dsName: 'setor_endp',
        mainField: { name: 'setor_endp', label: 'Setor' },
        advFields: [
            { name: 'codigo_endp', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'setor_endp', label: 'Setor', type: 'string', inputMode: 'text' },
            { name: 'rua_endp', label: 'Rua', type: 'string', inputMode: 'text' },
            { name: 'bloco_endp', label: 'Bloco', type: 'string', inputMode: 'text' },
            { name: 'andar_endp', label: 'Andar', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="setor_endp" sortable header="Setor"></Column>
            <Column field="rua_endp" sortable header="Rua"></Column>
            <Column field="bloco_endp" sortable header="Bloco"></Column>
            <Column field="andar_endp" sortable header="Andar"></Column>
        </FormList >
    )
}
